<title>Expertteam - Instellingen</title>
<app-headermenu></app-headermenu>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true,  primaryColour:'#63b5a2'}"></ngx-loading>

<div class="container container-zoeken">
  <h3>Instellingen
    <br>
    </h3>
    <hr>

      @if (emptyAccountSettings == true) {
        <div>
          @for (setting of settings; track setting) {
            <div>
              <div class="form-control-sm form-group row">
                <label for="example-text-input" class="col-sm-4 col-form-label">{{setting.descriptionNl}}</label>
                <div class="col-sm-4">
                  @if (setting.fieldType == 'select') {
                    <div>
                      <ng-select class="custom" [(ngModel)]="settingsModel[setting.id]">
                        @for (option of selectOptions[setting.id]?.options; track option) {
                          <ng-option [value]="option">{{option}}</ng-option>
                        }
                      </ng-select>
                    </div>
                  }
                  @if (setting.fieldType == 'text') {
                    <div>
                      <input [(ngModel)]="settingsModel[setting.id]" [disabled]="!setting.editableByUser" value="{{setting.defaultValue}}" class="form-control-sm form-control"
                        type="{{setting.fieldType}}" id="example-text-input">
                    </div>
                  }
                  @if (setting.fieldType == 'numeric') {
                    <div>
                      <input [(ngModel)]="settingsModel[setting.id]" [disabled]="!setting.editableByUser" type="numeric" value="{{setting.defaultValue}}"
                        class="form-control-sm form-control" type="number" id="example-text-input">
                    </div>
                  }
                </div>
                <br>
                </div>
              </div>
            }
          </div>
        }

        @if (emptyAccountSettings == false) {
          <div>
            @for (setting of settings; track setting) {
              <div>
                <div class="form-control-sm form-group row">
                  <label for="example-text-input" class="col-sm-4 col-form-label">{{setting.SettingType.descriptionNl}}</label>
                  <div class="col-sm-4">
                    @if (setting.SettingType.fieldType == 'select') {
                      <div>
                        <ng-select class="custom" [(ngModel)]="settingsModel[setting.id]">
                          @for (option of selectOptions[setting.id].options; track option) {
                            <ng-option [value]="option">{{option}}</ng-option>
                          }
                        </ng-select>
                      </div>
                    }
                    @if (setting.SettingType.fieldType == 'text') {
                      <div>
                        <input [(ngModel)]="settingsModel[setting.id]" [disabled]="!setting.SettingType.editableByUser" value="{{setting.defaultValue}}"
                          class="form-control-sm form-control" type="{{setting.fieldType}}" id="example-text-input">
                      </div>
                    }
                    @if (setting.SettingType.fieldType == 'numeric') {
                      <div>
                        <input [(ngModel)]="settingsModel[setting.id]" [disabled]="!setting.SettingType.editableByUser" value="{{setting.defaultValue}}"
                          class="form-control-sm form-control" type="number" id="example-text-input">
                      </div>
                    }
                  </div>
                </div>
                <br>
                </div>
              }
            </div>
          }

          <div class="form-control-sm form-group row">
            <div class="col-sm-4">
              <button style="background-color:#d65d8c" type="button" (click)="saveSettings()" class="btn btn-primary btn-sm">Opslaan</button>
            </div>
          </div>